"use client";

import { c as _c } from "react/compiler-runtime";
import { useState } from "react";
import { useTranslation } from "react-i18next";
import PaymentsAccessGuard from "@/components/payments/common/PaymentsAccessGuard";
import PaymentsPageHeader from "@/components/payments/common/PaymentsPageHeader";
import SegmentedControl from "@/components/payments/common/SegmentedControl";
import PaymentsSharedFilters from "@/components/payments/common/PaymentsSharedFilters";
import PaymentsKpi from "@/components/payments/kpi/PaymentsKpi";
import MissingCardPaymentsTable from "@/components/payments/missing-card-payments/MissingCardPaymentsTable";
import NationalTransfersTable from "@/components/payments/national-transfers/NationalTransfersTable";
import TelecollectionsTable from "@/components/payments/telecollections/TelecollectionsTable";
import type { PaymentsTabKey } from "@/types/payments";
export default function Home() {
  const $ = _c(39);
  const {
    t
  } = useTranslation();
  const [activeTab, setActiveTab] = useState("national_transfers");
  let t0;
  if ($[0] !== t) {
    t0 = t("paymentsReceived.tabs.nationalTransfers");
    $[0] = t;
    $[1] = t0;
  } else {
    t0 = $[1];
  }
  let t1;
  if ($[2] !== t0) {
    t1 = {
      key: "national_transfers",
      label: t0
    };
    $[2] = t0;
    $[3] = t1;
  } else {
    t1 = $[3];
  }
  let t2;
  if ($[4] !== t) {
    t2 = t("paymentsReceived.tabs.telecollections");
    $[4] = t;
    $[5] = t2;
  } else {
    t2 = $[5];
  }
  let t3;
  if ($[6] !== t2) {
    t3 = {
      key: "telecollections",
      label: t2
    };
    $[6] = t2;
    $[7] = t3;
  } else {
    t3 = $[7];
  }
  let t4;
  if ($[8] !== t) {
    t4 = t("paymentsReceived.tabs.missingCardPayments");
    $[8] = t;
    $[9] = t4;
  } else {
    t4 = $[9];
  }
  let t5;
  if ($[10] !== t4) {
    t5 = {
      key: "missing_card_payments",
      label: t4
    };
    $[10] = t4;
    $[11] = t5;
  } else {
    t5 = $[11];
  }
  let t6;
  if ($[12] !== t1 || $[13] !== t3 || $[14] !== t5) {
    t6 = [t1, t3, t5];
    $[12] = t1;
    $[13] = t3;
    $[14] = t5;
    $[15] = t6;
  } else {
    t6 = $[15];
  }
  const tabs = t6;
  let t7;
  let t8;
  if ($[16] === Symbol.for("react.memo_cache_sentinel")) {
    t7 = <PaymentsPageHeader />;
    t8 = <PaymentsKpi />;
    $[16] = t7;
    $[17] = t8;
  } else {
    t7 = $[16];
    t8 = $[17];
  }
  const t9 = activeTab === "national_transfers";
  let t10;
  if ($[18] !== t9) {
    t10 = <PaymentsSharedFilters isAccountFilter={t9} />;
    $[18] = t9;
    $[19] = t10;
  } else {
    t10 = $[19];
  }
  let t11;
  if ($[20] !== t) {
    t11 = t("paymentsReceived.title");
    $[20] = t;
    $[21] = t11;
  } else {
    t11 = $[21];
  }
  let t12;
  if ($[22] === Symbol.for("react.memo_cache_sentinel")) {
    t12 = key => setActiveTab(key as PaymentsTabKey);
    $[22] = t12;
  } else {
    t12 = $[22];
  }
  let t13;
  if ($[23] !== activeTab || $[24] !== t11 || $[25] !== tabs) {
    t13 = <div className="mb-4"><SegmentedControl ariaLabel={t11} options={tabs} value={activeTab} onChange={t12} /></div>;
    $[23] = activeTab;
    $[24] = t11;
    $[25] = tabs;
    $[26] = t13;
  } else {
    t13 = $[26];
  }
  let t14;
  if ($[27] !== activeTab) {
    t14 = activeTab === "telecollections" && <TelecollectionsTable />;
    $[27] = activeTab;
    $[28] = t14;
  } else {
    t14 = $[28];
  }
  let t15;
  if ($[29] !== activeTab) {
    t15 = activeTab === "missing_card_payments" && <MissingCardPaymentsTable />;
    $[29] = activeTab;
    $[30] = t15;
  } else {
    t15 = $[30];
  }
  let t16;
  if ($[31] !== activeTab) {
    t16 = activeTab === "national_transfers" && <NationalTransfersTable />;
    $[31] = activeTab;
    $[32] = t16;
  } else {
    t16 = $[32];
  }
  let t17;
  if ($[33] !== t10 || $[34] !== t13 || $[35] !== t14 || $[36] !== t15 || $[37] !== t16) {
    t17 = <PaymentsAccessGuard><div className="p-6">{t7}{t8}{t10}{t13}{t14}{t15}{t16}</div></PaymentsAccessGuard>;
    $[33] = t10;
    $[34] = t13;
    $[35] = t14;
    $[36] = t15;
    $[37] = t16;
    $[38] = t17;
  } else {
    t17 = $[38];
  }
  return t17;
}